import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["componentClass", "className", "order", "span", "offset", "push", "pull", "clsPrefix"];

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js";
import omit from "omit.js";
var propTypes = {
  componentClass: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),

  /**
   * xs显示列数
   */
  xs: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),

  /**
   * sm显示列数
   */
  sm: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),

  /**
   * md显示列数
   */
  md: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),

  /**
   * lg显示列数
   */
  lg: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),

  /**
   * xs偏移列数
   */
  xsOffset: PropTypes.number,

  /**
   * sm偏移列数
   */
  smOffset: PropTypes.number,

  /**
   * md偏移列数
   */
  mdOffset: PropTypes.number,

  /**
   * lg偏移列数
   */
  lgOffset: PropTypes.number,

  /**
   * xs右偏移列数
   */
  xsPush: PropTypes.number,

  /**
   * sm右偏移列数
   */
  smPush: PropTypes.number,

  /**
   * md右偏移列数
   */
  mdPush: PropTypes.number,

  /**
   * lg右偏移列数
   */
  lgPush: PropTypes.number,

  /**
   * xs左偏移列数
   */
  xsPull: PropTypes.number,

  /**
   * sm左偏移列数
   */
  smPull: PropTypes.number,

  /**
   * md左偏移列数
   */
  mdPull: PropTypes.number,

  /**
   * lg左偏移列数
   */
  lgPull: PropTypes.number,

  /**
   * 显示列数
   */
  span: PropTypes.number,

  /**
   * 偏移列数
   */
  offset: PropTypes.number,

  /**
  * 左偏移列数
  */
  pull: PropTypes.number,

  /**
   * 右偏移列数
   */
  push: PropTypes.number
};
var defaultProps = {
  componentClass: 'div'
};
var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
var Col = (_dec = WebUI({
  name: "col",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Col, _Component);

  var _super = _createSuper(Col);

  function Col(props) {
    _classCallCheck(this, Col);

    return _super.call(this, props);
  }

  _createClass(Col, [{
    key: "render",
    value: function render() {
      var _this = this,
          _ref;

      var _this$props = this.props,
          Component = _this$props.componentClass,
          className = _this$props.className,
          order = _this$props.order,
          span = _this$props.span,
          offset = _this$props.offset,
          push = _this$props.push,
          pull = _this$props.pull,
          clsPrefix = _this$props.clsPrefix,
          others = _objectWithoutProperties(_this$props, _excluded);

      var tbClass = [];

      var tbClassObj = _defineProperty({}, clsPrefix, true);
      /**
       * 对传入props做样式转化
       * @type {[type]}
       */


      DEVICE_SIZES.forEach(function (size) {
        var _objectSpread2;

        var sizeProps = {};
        var propSize = _this.props[size];

        function popProp(propSuffix, modifier) {
          if (typeof propSize === 'number') {
            sizeProps.span = propSize;
          } else if (_typeof(propSize) === 'object') {
            sizeProps = propSize || {};
          }

          var propName = "".concat(size).concat(propSuffix);
          var propValue = others[propName];

          if (typeof propValue === 'number' && propValue != undefined && propValue != null) {
            tbClass.push("".concat(clsPrefix, "-").concat(size).concat(modifier, "-").concat(propValue));
          }

          delete others[size];
          delete others[propName];
        }

        popProp('', '');
        popProp('Offset', '-offset');
        popProp('Push', '-push');
        popProp('Pull', '-pull'); // antd

        tbClassObj = _objectSpread(_objectSpread({}, tbClassObj), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, "".concat(clsPrefix, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), _defineProperty(_objectSpread2, "".concat(clsPrefix, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), _defineProperty(_objectSpread2, "".concat(clsPrefix, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), _defineProperty(_objectSpread2, "".concat(clsPrefix, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), _defineProperty(_objectSpread2, "".concat(clsPrefix, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), _objectSpread2));
      });
      return /*#__PURE__*/React.createElement(Component, _extends({
        className: classNames.apply(void 0, tbClass.concat([tbClassObj, (_ref = {}, _defineProperty(_ref, "".concat(clsPrefix, "-").concat(span), span !== undefined), _defineProperty(_ref, "".concat(clsPrefix, "-order-").concat(order), order), _defineProperty(_ref, "".concat(clsPrefix, "-offset-").concat(offset), offset), _defineProperty(_ref, "".concat(clsPrefix, "-push-").concat(push), push), _defineProperty(_ref, "".concat(clsPrefix, "-pull-").concat(pull), pull), _ref), className]))
      }, others), this.props.children);
    }
  }]);

  return Col;
}(Component)) || _class);
Col.propTypes = propTypes;
export default Col;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-layout/src/Col.js